var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"spa-container"},[_c('el-aside',{attrs:{"width":"200px"}},[_c('Aside')],1),_c('el-container',{staticClass:"right-container"},[_c('el-header',[_c('Header')],1),_c('el-main',[_c('keep-alive',{attrs:{"include":['MenuAes', 'MenuSnowflake']}},[_c('router-view')],1)],1),_c('el-footer',[_c('Footer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }